import { useFileUpload } from 'hooks/use-file-upload/useFileUpload'
import { useNotification } from 'hooks/use-notification/useNotification'
import { accountSettingsStoreState } from 'models/account-settings/account-settings.store'
import { useEditProfile } from './useEditProfile'
import { onboardingStoreState } from 'models/onboarding/onboarding.store'
import { BackendUser } from 'common/types'
import { useState } from 'react'

export const useAddAvatar = (user: BackendUser, setNewProfileData: Function) => {
  const { notify } = useNotification()
  const { editProfileQuestions, setEditProfileQuestions } = onboardingStoreState
  const { updatedQuestionAnswers, completeEditOnboarding } = useEditProfile()
  const { getProcessedFile } = useFileUpload()
  const { setAvatarUpdated } = accountSettingsStoreState
  const [fileName, setFileName] = useState<string>()
  const [previewImage, setPreviewImage] = useState<string>()

  const { setUpdateButtonEnabled } = onboardingStoreState
  const aws = process.env.REACT_APP_AWS_BUCKET_NAME as string
  const avatar = editProfileQuestions?.find(x => x.question.includes('avatar'))
  const handleImageUpload = e => {
    const maxImageFileSize = 5
    const files = e.target.files
    const fsMb = files[0]?.size / (1024 * 1024)
    if (fsMb > maxImageFileSize) {
      notify('error', 'Upload limit for an image is 5MB')
      e.target.value = ''
      setPreviewImage(user?.image)
      setAvatarUpdated(false)
      setFileName('')
      return false
    }
    getProcessedFile(files, ['jpeg', 'jpg', 'png'], 'stream', async ({ file }: any) => {
      const avatar = editProfileQuestions.find(x => x.question.includes('avatar'))
      const fileNameArray = files[0]?.name?.toLowerCase()?.split('.')
      if (avatar) {
        avatar.userAnswer = JSON.stringify({ file: file, type: fileNameArray[fileNameArray.length - 1] })
        setNewProfileData((prevData) => {
          const updatedData = prevData.map((item) => {
            if (item.question === avatar.question) {
              return { question: avatar.question, answer: avatar.userAnswer };
            } else {
              return item;
            }
          });
          return updatedData;
        });
        setUpdateButtonEnabled(true)
      }
      setPreviewImage(URL.createObjectURL(e.target.files[0]))
      setFileName(files[0]?.name)
      setAvatarUpdated(true)
      e.target.value = ''
    })
  }

  const handleRemoveImage = e => {
    avatar.userAnswer = ''
    setPreviewImage(`https://${aws}.s3.amazonaws.com/media/images/defaultImage.png`)
    setNewProfileData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.question === avatar.question) {
          return { question: avatar.question, answer: avatar.userAnswer };
        } else {
          return item;
        }
      });
      return updatedData;
    });
    e.target.value = ''
    setUpdateButtonEnabled(true)
  }

  return { handleImageUpload, handleRemoveImage, fileName, previewImage } as const
}
